import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import SEO from "../common/SEO";
import CounterUpTwo from "../component/counterup/CounterUpTwo";
import AboutThree from "../component/about/AboutThree";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import ClientSlider from "../component/client/ClientSlider";
import ProjectOne from "../component/project/ProjectOne";

const Industry = () => {
  return (
    <>
      <SEO title="Industry" />
      <main className="main-wrapper">
        <HeaderOne />

        <BreadCrumbOne
          subtitle="Expert Services Across Industries "
          title="Industry We serve"
          page="Industry"
        />

        <ProjectOne title="" subtitle="" isHomePage={false} />

        <CounterUpTwo />
        <AboutThree />
        <div className="container " style={{ paddingTop: "100px" }}>
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>

        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35"
          parentClass="your-custom-class"
        />

        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default Industry;
